<template>
	<el-dialog title="" center :visible="password" @close="close" :close-on-click-modal="false">
		<span class="type_size_30 subject_color">修改密码</span>
		<div class="p_flex p_logins  p_f_a p_m_t_30">
			<span class="p_m_l_30 type_size_18 ">原密码</span>
			<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="text" v-model="pass" placeholder="请输入原密码"></el-input></div>
		</div>
		<div class="p_flex p_logins p_f_a p_m_t_30">
			<span class="p_m_l_30 type_size_18 ">新密码</span>
			<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="text" v-model="passwordd" placeholder="请输入密码"></el-input></div>
		</div>
		<div class="p_flex p_logins p_f_a p_m_t_30">
			<span class="p_m_l_30 type_size_18 ">确认密码</span>
			<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="text" v-model="passwords" placeholder="请输入密码"></el-input></div>
		</div>
		<div class="p_flex p_f_c p_m_t_30" @click="goButton"><el-button type="success">确认</el-button></div>
	</el-dialog>
</template>

<script>
export default {
	props: {
		password: null
	},
	data() {
		return {
			pass:"", //源 
			passwordd:"", //新
			passwords: '' ,//新确认
		}; 
	},

	mounted() {},
	methods: {
		close() {
			this.$emit('closesp', false);
		},
		goButton() {
			if(!this.pass || !this.passwordd || !this.passwords){
					this.$message.error("密码不能为空！")
					return
			}
			if(this.passwordd!=this.passwords){
					this.$message.error("新密码和确认密码必须一致！")
					return
			}
			this.$request.ajax(this).post("/api/update_password",{
					old_password:this.pass,
					password:this.passwordd
			}).then(res=>{
				// console.log(res)
				this.$message({
					message: '修改密码成功!',
					type: 'success'
					});
				this.$emit('goButtonp', false);
			})
		}
	}
};
</script>

<style lang="scss" scoped>
.content_box {
	padding: 20px 0;
}
.subject_red {
	color: #f1282e;
}
>>> .el-input__inner {
	border: none;
	background-color: #f5f5f5;
	font-size: 18px;
	color: #333;
	padding: 0;
}
.p_logins{
	height: 64px;
	background: #F5F5F5;
	opacity: 1;
	border-radius: 10px;
}

>>> input::-webkit-input-placeholder {
	font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/user/commponents/password.vue